import React, { useState, useEffect, useMemo } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { commonCountryServices } from "../api/useQueryHooks";
import { createFilterOptions } from "@mui/material/Autocomplete";
import moment from "moment";

import AddRestaurantImagesUpload from "./../components/AddRestaurantImagesUpload";
import RestaurantBtn from "./RestaurantBtn";
import AlertMsg from "./AlertMsg";
import SelectizeTextField from "./SelectizeTextField";
import SwitchInput from "./SwitchInput";
import FormTimePickers from "./FormTimePicker";
import SettingTextField from "./SettingTextField";

import {
  THEME_COLOR,
  THEME_COLOR2,
  THEME_COLOR3,
  THEME_COLOR4,
  VAT_NUM_VAL,
  VAT_VAL,
} from "../constants";

import "./../assets/css/custom.css";

const theme = createTheme({
  palette: {
    gray: {
      main: THEME_COLOR4,
    },
    yellow: {
      main: THEME_COLOR,
    },
  },
});

const APPLY_VAT_LIST = [
  "Apply VAT automatically in billing",
  "Apply VAT manually in billing",
];

// Convert a 2-letter ISO country code (e.g. "GB") to its flag emoji.
const isoToFlag = (iso) => {
  if (!iso || iso.length !== 2) return "";
  return String.fromCodePoint(
    ...iso
      .toUpperCase()
      .split("")
      .map((ch) => 127397 + ch.charCodeAt(0)),
  );
};

// Filter phone-code options by country name or dial code as the user types.
const countryFilter = createFilterOptions({
  stringify: (option) => `${option.label} ${option.code}`,
});

const AddRestaurantInfo = (props) => {
  const [category, setCategory] = useState("");
  const [option, setOption] = useState("dine_in");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobileCode, setMobileCode] = useState("");
  const [mobile, setMobile] = useState(null);
  const [desc, setDesc] = useState("");
  const [slug, setSlug] = useState("");
  const [vatVal, setVatVal] = useState(VAT_VAL);
  const [vatNum, setVatNum] = useState(VAT_NUM_VAL);
  const [vatEnabled, setVatEnabled] = useState(false);
  const [applyVatVal, setApplyVatVal] = useState(APPLY_VAT_LIST[0]);
  const [logoImage, setLogoImage] = useState("");
  const [imageList, setImageList] = useState([]);
  const [imageLoading, setImageLoading] = useState(false);
  const [msgAlert, setMsgAlert] = useState({
    open: false,
    message: "",
    msgType: "error",
  });

  const { data: countries = [], isError: countriesError } = commonCountryServices.useGetCountryList();

  const countryList = useMemo(
    () =>
      countries.map((c) => ({
        country: c.isoCode,
        code: `${c.phoneCode}`,
        label: c.name,
        flag: isoToFlag(c.isoCode),
        name: `${c.name} (${c.phoneCode})`,
      })),
    [countries],
  );

  useEffect(() => {
    if (countriesError) {
      setMsgAlert({ open: true, message: "Failed to load country list", msgType: "error" });
    }
  }, [countriesError]);

  useEffect(() => {
    if (!countryList.length) return;
    let filter = countryList.filter((x) => x.country == props.countryCode);
    if (filter.length) {
      let data = filter[0];
      setMobileCode(data);
      let code1 = data.code;

      if (props.mobile?.includes(code1, 0)) {
        setMobile(props.mobile?.replace(code1, ""));
      }
    } else {
      // Try to match any country code from the phone number
      const mobile = props.mobile || "";
      const sorted = [...countryList].sort(
        (a, b) => b.code.length - a.code.length,
      );
      const match = sorted.find((x) => mobile.startsWith(x.code));
      if (match) {
        setMobileCode(match);
        setMobile(mobile.slice(match.code.length));
      } else {
        setMobile(mobile.replace(/^\+/, ""));
      }
    }
  }, [countryList, props.countryCode, props.mobile]);

  useEffect(() => {
    setName(props.name);
    setEmail(props.email);
    setDesc(props.desc);
    setSlug(props?.slug);
    setCategory(props.category);
    setOption(props.option);
    setVatVal(props?.vat);
    setVatNum(props?.vatNum);
    setVatEnabled(props?.vat > 0);

    // if (props.type == 'add') {
    //   setLogoImage(props.logo);
    //   setImageList(props.imageList);
    // }
  }, [props.name, props.email, props.desc, props.slug, props.category, props.option, props.vat, props.vatNum]);

  useEffect(() => {
    // if (props.type == 'add') {
    //   let upload_list = imageList.filter(x => x.upload == false);
    //   if (upload_list.length > 0) {
    //     setImageLoading(true);
    //   } else {
    //     setImageLoading(false);
    //   }
    // }
  }, [imageList]);

  const onCheckboxClick = (val) => {
    setOption(val);
  };

  const onNextBtnClick = (e) => {
    e.preventDefault();
    // if(props.type == 'add') {
    //   if (data.logo == '') {
    //     setMsgAlert({open: true, message: 'Logo is required', msgType: 'error'});
    //     return;
    //   }
    //
    //   if (data.imageList.length <= 0) {
    //     setMsgAlert({open: true, message: 'Image is required', msgType: 'error'});
    //     return;
    //   }
    // }

    if (props.type == "add") {
      let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      if (reg.test(email) == false) {
        setMsgAlert({ open: true, message: "Invalid Email", msgType: "error" });
        return;
      }
    }

    if (
      mobileCode == null ||
      typeof mobileCode?.code == "undefined" ||
      typeof mobileCode?.country == "undefined"
    ) {
      setMsgAlert({
        open: true,
        message: "Mobile Code is required",
        msgType: "error",
      });
      return;
    }

    if (/[^0-9]/g.test(mobile)) {
      setMsgAlert({
        open: true,
        message: "Invalid Contact Number",
        msgType: "error",
      });
      return;
    }

    if (mobile.length < 5) {
      setMsgAlert({
        open: true,
        message: "Minimum length 5 is required for Contact Number",
        msgType: "error",
      });
      return;
    }

    if (vatEnabled && vatNum <= 0) {
      setMsgAlert({
        open: true,
        message: "VAT number is required",
        msgType: "error",
      });
      return;
    }

    if (vatEnabled && vatVal <= 0) {
      setMsgAlert({
        open: true,
        message: "VAT in % is required",
        msgType: "error",
      });
      return;
    }

    if (slug) {
      if (/[^A-Za-z]/g.test(slug)) {
        setMsgAlert({
          open: true,
          message: "Only characters are allowed",
          msgType: "error",
        });
        return;
      }
    }

    let data = {
      name: name,
      email: email,
      countryCode: mobileCode?.country,
      mobile: mobileCode?.code + "" + mobile,
      desc: desc,
      slug: slug,
      option: option,
      category: category,
      vat: vatVal,
      vatNum: vatNum,
      // imageList: imageList,
      // logo: logoImage,
    };

    props.resInfo(data);
  };

  const handlerOnChange = (type, value) => {
    if (type === "vat") {
      setVatVal(value.replace(/[^0-9]/g, ""));
    } else if (type === "vatNum") {
      setVatNum(value.replace(/[^0-9.]/g, ""));
    } else if (type === "applyVat") {
      setApplyVatVal(value);
    }
  };

  const handlerOnVatChange = () => {
    setVatEnabled(!vatEnabled);
    setVatVal(vatEnabled ? 0 : VAT_VAL);
    setVatNum(vatEnabled ? 0 : VAT_NUM_VAL);
  };

  // const uploadFile = (list, loading, type) => {
  //   if (type == 'loading') {
  //     setImageList(prev => [...prev, list]);
  //   } else if (type == 'success') {
  //     setImageList(prev => prev.map((el) => el.id == list.id ? {...el, ...list} : el));
  //   } else if (type == 'error') {
  //     setImageList(prev => prev.filter(x => x.id !== list.id))
  //   }
  // }
  //
  // const uploadLogoFile = (data) => {
  //   setLogoImage(data);
  //   setImageLoading(false);
  // }

  return (
    <Grid component="form" autoComplete="off" onSubmit={onNextBtnClick}>
      {/*{props.type == 'add' ?*/}
      {/*  <Grid mb={5}>*/}
      {/*    <AddRestaurantImagesUpload*/}
      {/*      logoImage={logoImage}*/}
      {/*      imageList={imageList}*/}
      {/*      imageLoading={imageLoading}*/}
      {/*      setImageLoading={setImageLoading}*/}
      {/*      onSetAlertMsg={setMsgAlert}*/}
      {/*      uploadFile={uploadFile}*/}
      {/*      uploadLogoFile={uploadLogoFile}*/}
      {/*    />*/}
      {/*  </Grid> : null}*/}

      <Grid
        container
        direction="row"
        item
        xs={12}
        justifyContent="space-between"
      >
        <Grid item xs={12} md={5.3} className="restaurant-first-data-grid">
          <Grid>
            <ThemeProvider theme={theme}>
              <TextField
                focused
                fullWidth
                required
                id="name"
                label="Name"
                color="gray"
                variant="standard"
                value={name}
                onChange={(e) => setName(e.target.value)}
                InputLabelProps={{
                  style: { color: THEME_COLOR3 },
                  sx: { ...styles.inputLabelText },
                }}
                inputProps={{
                  autoComplete: "none",
                  sx: { ...styles.textInputValue },
                }}
              />
            </ThemeProvider>
          </Grid>
          <Grid className="restaurant-data-grid">
            <ThemeProvider theme={theme}>
              <TextField
                required
                focused
                fullWidth
                id="email"
                label="Email"
                color="gray"
                type="email"
                variant="standard"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                InputLabelProps={{
                  style: { color: THEME_COLOR3 },
                  sx: { ...styles.inputLabelText },
                }}
                inputProps={{
                  autoComplete: "none",
                  sx: { ...styles.textInputValue },
                }}
              />
            </ThemeProvider>
          </Grid>
          <Grid mt={"24px"}>
            <label className="restaurant-label" style={styles.labelText}>
              Contact Number *
            </label>
            <ThemeProvider theme={theme}>
              <Grid
                container
                direction="row"
                style={{ alignItems: "flex-end" }}
              >
                <Grid item xs={4}>
                  <SelectizeTextField
                    page={"AddRestaurantInfo"}
                    multiple={false}
                    value={mobileCode}
                    onChange={(val) => {
                      setMobileCode(val);
                    }}
                    backgroundColor={"transparent"}
                    options={countryList}
                    variant={"filled"}
                    label={""}
                    placeholder={"+44"}
                    borderBottom={"2px solid " + THEME_COLOR4}
                    borderRadius={"0px"}
                    disableClearable={true}
                    paperMinWidth={280}
                    isOptionEqualToValue={(option, value) =>
                      option?.country === value?.country
                    }
                    filterOptions={countryFilter}
                    getOptionLabel={(option) =>
                      typeof option === "string"
                        ? option
                        : `${option.flag ? option.flag + " " : ""}${option.code}`
                    }
                    renderOption={(optionProps, option) => (
                      <Box
                        component="li"
                        {...optionProps}
                        key={option.country}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          whiteSpace: "nowrap",
                          fontSize: 13,
                          fontFamily: "GilroySemiBold",
                        }}
                      >
                        <span style={{ fontSize: 16 }}>{option.flag}</span>
                        <span style={{ flexGrow: 1 }}>{option.label}</span>
                        <span style={{ color: THEME_COLOR3 }}>
                          {option.code}
                        </span>
                      </Box>
                    )}
                  />
                </Grid>
                <Grid item xs={8}>
                  <Input
                    required
                    disableUnderline
                    id="contactNumber"
                    color="gray"
                    sx={{ ...styles.selectBox, width: "100%" }}
                    value={mobile}
                    onChange={(e) =>
                      setMobile(
                        e.target.value?.replace(/[^0-9]/g, "").slice(0, 10),
                      )
                    }
                    inputProps={{
                      autoComplete: "none",
                      pl: 1,
                      sx: {
                        "&::placeholder": {
                          fontSize: 13,
                        },
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </ThemeProvider>
          </Grid>

          <Grid className="restaurant-data-grid">
            <Box style={styles.vatLabelView}>
              <label className="restaurant-label" style={styles.labelText}>
                Is VAT applicable?
              </label>
              <Box ml={1}>
                <SwitchInput
                  checked={vatEnabled}
                  onChange={handlerOnVatChange}
                />
              </Box>
            </Box>
            {vatEnabled ? (
              <>
                <Grid container item xs={12} spacing={2}>
                  <Grid item xs={12} md={6} mt={1}>
                    <SettingTextField
                      page={"AddRestaurantInfo"}
                      value={vatNum}
                      setValue={(val) => handlerOnChange("vatNum", val)}
                      editable={true}
                      required={vatEnabled}
                      textInputCss={styles.textInputCss}
                      borderRadius={"0px"}
                      label={"VAT Number"}
                      labelStyle={styles.labelText}
                      inputTextStyle={styles.textInputValue}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} mt={1}>
                    <SettingTextField
                      page={"AddRestaurantInfo"}
                      value={vatVal}
                      setValue={(val) => handlerOnChange("vat", val)}
                      editable={true}
                      required={vatEnabled}
                      textInputCss={styles.textInputCss}
                      borderRadius={"0px"}
                      label={"VAT in %"}
                      labelStyle={styles.labelText}
                      inputTextStyle={styles.textInputValue}
                    />
                  </Grid>
                </Grid>
                <Box mt={3}>
                  <ThemeProvider theme={theme}>
                    <Select
                      required
                      fullWidth
                      disableUnderline
                      sx={styles.selectBox}
                      color="gray"
                      variant="standard"
                      value={applyVatVal}
                      onChange={(event) =>
                        handlerOnChange("applyVat", event.target.value)
                      }
                    >
                      {APPLY_VAT_LIST.map((item, index) => (
                        <MenuItem
                          sx={styles.menuItemText}
                          key={index}
                          value={item}
                        >
                          {item}
                        </MenuItem>
                      ))}
                    </Select>
                  </ThemeProvider>
                </Box>
              </>
            ) : null}
          </Grid>
        </Grid>

        <Grid item xs={12} md={5.3} className="restaurant-second-data-grid">
          <Grid>
            <label className="restaurant-label" style={styles.labelText}>
              Category
            </label>
            <ThemeProvider theme={theme}>
              <Select
                fullWidth
                required
                disableUnderline
                sx={styles.selectBox}
                color="gray"
                variant="standard"
                value={category}
                onChange={(event) => setCategory(event.target.value)}
              >
                {props.categoryList.map((item, index) => (
                  <MenuItem
                    sx={styles.menuItemText}
                    key={index}
                    value={item._id}
                  >
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </ThemeProvider>
          </Grid>
          <Grid className="restaurant-data-grid">
            <ThemeProvider theme={theme}>
              <TextField
                multiline
                fullWidth
                focused
                required
                id="description"
                label="Description"
                color="gray"
                rows={5}
                variant="standard"
                value={desc}
                onChange={(e) => setDesc(e.target.value)}
                InputLabelProps={{
                  style: { color: THEME_COLOR3 },
                  sx: { ...styles.inputLabelText },
                }}
                inputProps={{
                  autoComplete: "none",
                  sx: { ...styles.textInputValue },
                }}
              />
            </ThemeProvider>
          </Grid>
          <Grid className="restaurant-data-grid">
            <ThemeProvider theme={theme}>
              <TextField
                focused
                fullWidth
                required={false}
                id="slug"
                label="Slug"
                color="gray"
                variant="standard"
                value={slug}
                onChange={(e) => setSlug(e.target.value)}
                InputLabelProps={{
                  style: { color: THEME_COLOR3 },
                  sx: { ...styles.inputLabelText },
                }}
                inputProps={{
                  autoComplete: "none",
                  sx: { ...styles.textInputValue },
                }}
              />
            </ThemeProvider>
          </Grid>
          <Grid className="restaurant-data-grid">
            <label className="restaurant-label" style={styles.labelText}>
              Options
            </label>
            <ThemeProvider theme={theme}>
              <FormGroup className="restaurant-main-option">
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      color="yellow"
                      checked={option === "dine_in"}
                      onChange={() => onCheckboxClick("dine_in")}
                    />
                  }
                  label={
                    <Typography sx={styles.optionLabel}>Dine in</Typography>
                  }
                  className="restaurant-option"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      color="yellow"
                      checked={option === "take_away"}
                      onChange={() => onCheckboxClick("take_away")}
                    />
                  }
                  label={
                    <Typography sx={styles.optionLabel}>Take Away</Typography>
                  }
                  className="restaurant-option"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      color="yellow"
                      checked={option === "both"}
                      onChange={() => onCheckboxClick("both")}
                    />
                  }
                  label={<Typography sx={styles.optionLabel}>Both</Typography>}
                />
              </FormGroup>
            </ThemeProvider>
          </Grid>
        </Grid>
      </Grid>
      <RestaurantBtn activeTab={0} loading={imageLoading} />
      <AlertMsg
        msgAlert={msgAlert}
        onCloseAlertMsg={() =>
          setMsgAlert({ open: false, message: "", msgType: "error" })
        }
      />
    </Grid>
  );
};

export default AddRestaurantInfo;

const styles = {
  labelText: {
    fontSize: 12,
    color: THEME_COLOR3,
    fontFamily: "GilroyRegular",
  },
  inputLabelText: {
    fontFamily: "GilroyRegular",
  },
  textInputValue: {
    fontSize: 14,
    fontFamily: "GilroySemiBold",
  },
  textInputCss: {
    "& .MuiInputBase-root": {
      height: 29,
      borderBottom: `2px solid #c4c4c4`,
      "&:before, :after, :hover:not(.Mui-disabled):before": {
        borderBottom: 0,
      },
    },
  },
  vatLabelView: {
    display: "flex",
    alignItems: "center",
  },
  callCodeText: {
    fontSize: 14,
    fontFamily: "GilroySemiBold",
    color: "#000",
  },
  selectBox: {
    borderBottom: "2px solid " + THEME_COLOR4,
    fontSize: 14,
    fontFamily: "GilroySemiBold",
  },
  menuItemText: {
    fontSize: 13,
    fontFamily: "GilroySemiBold",
  },
  optionLabel: {
    fontSize: 13,
    fontFamily: "GilroySemiBold",
  },
};
